module.exports = __webpack_public_path__ + "img/opening-column-left.f24c59d9.svg";